import { Injectable } from '@angular/core';
import { HttpInterceptor, HttpHandler, HttpRequest } from '@angular/common/http';
import { POLEnvironmentConstants } from '../constants/pol-environment.constants';
import { Store } from '@ngrx/store';
import * as polCoreActions from 'src/app/core/state/core.actions';

@Injectable()
export class ApiInterceptor implements HttpInterceptor {
  constructor(private store: Store) { }

  intercept(req: HttpRequest<any>, next: HttpHandler): any {
    const baseUrl = POLEnvironmentConstants.baseUrl;
    const apiReq = req.clone({ url: `${baseUrl}${req.url}` });
    this.store.dispatch(polCoreActions.resetIdleTimeout());
    return next.handle(apiReq);
  }
}
